import { render } from "./agentManage.vue?vue&type=template&id=a54f948e&scoped=true"
import script from "./agentManage.vue?vue&type=script&lang=js"
export * from "./agentManage.vue?vue&type=script&lang=js"

import "./agentManage.vue?vue&type=style&index=0&id=a54f948e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a54f948e"]])

export default __exports__